module.exports = __webpack_public_path__ + "static/media/E19.c2f338f1.jpg";